<button (click)="downloadParsedResult()" mat-flat-button [matTooltip]="'common.buttons.download' | transloco"
    matTooltipClass="reghub-tooltip" [attr.aria-label]="'downloadParsedResult.downloadParsedResult' | transloco" color="accent"
    data-testid="parsed-result-download-button">
    <mat-icon>description</mat-icon>
    <mat-label>{{ documentName }}</mat-label>
</button>